document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('contact_form');
  const popup = document.getElementById('popup');
  const popupContent = document.querySelector('.popup-content');
  const continueButton = document.getElementById('continueButton');

  // Check if the form was just submitted successfully
  if (window.location.search.includes('contact_posted=true')) {
    // Show the popup
    showPopup();
    // Clear the URL parameters
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  if (continueButton) {
    continueButton.addEventListener('click', hidePopup);
  }

  // Close popup when clicking outside the popup content
  popup.addEventListener('click', function(event) {
    if (event.target === popup) {
      hidePopup();
    }
  });

  // Prevent clicks inside the popup content from closing the popup
  popupContent.addEventListener('click', function(event) {
    event.stopPropagation();
  });

  function showPopup() {
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden'; // Prevent scrolling when popup is open
  }

  function hidePopup() {
    popup.style.display = 'none';
    document.body.style.overflow = ''; // Restore scrolling
  }
});
